import React, {Component} from 'react'

import styles from './ModalOverlay.css'
import posed, {PoseGroup} from "react-pose";


const ModalWrapper = posed.div({
    enter: {opacity: 1},
    exit: {opacity: 0}
})

export default class ModalOverlay extends Component {
    state = {
        isVisible: this.props.visible
    };

    static getDerivedStateFromProps(props, state) {
        if (props.visible !== state.isVisible) {
            return {
                isVisible: props.visible
            };
        }
        return null;
    }

    render() {
        const {closeAction} = this.props;
        const {isVisible} = this.state;

        return (
            <PoseGroup>
                {
                    isVisible && [

                        <ModalWrapper className={styles.overlay} onClick={closeAction} key="modalOverlay" />

                    ]
                }

            </PoseGroup>
        )
    }
}



// WEBPACK FOOTER //
// ./src/components/ModalOverlay/ModalOverlay.js